import script from "./DataProviderEditEntityTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataProviderEditEntityTab.vue?vue&type=script&lang=ts&setup=true"

import "./DataProviderEditEntityTab.vue?vue&type=style&index=0&id=885554d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885554d0"]])

export default __exports__